import React from "react";
import Select from 'react-select'

function InputColore(props) {
        
    //const prodottoTemp=props.prodottoTemp;

    const objOpzioni = props.objOpzioni;    

    const inputLabel=props.inputLabel;
    //const datoName=props.datoName;
    const datoId=props.datoId;
    //const datoValue=props.datoValue;
    //const datoOnChange= props.datoOnChange;
    //const datoClass= props.datoClass;
    
    /* const controllaValue = function(val,ind) {
        if (datoValue === val.idPS && datoValue !== "") {
            return <option key={ind} selected value={val.idPS} >{val.desc}</option>
          } else {
            return <option key={ind} value={val.idPS} >{val.desc}</option>
          }
    } */

    const trasformaArrayPerSelect = function(el,i) {
        return({
            value: el.idPS,
            label: el.desc
        })
    }

    const opzioniSelect = objOpzioni.map(trasformaArrayPerSelect)

    return (
        <div className="mb2">
            <label for={datoId}>{inputLabel}</label><br />       
                
                {/* <select
                    name={datoName}
                    id={datoId}
                    className={datoClass}
                    onChange={datoOnChange}
                >                    
                    {datoValue === "" && <option key="null" selected value="" >--</option>} 
                    {
                    objOpzioni.map(controllaValue)                    
                    }
                </select>   */}   
                <Select options={opzioniSelect} /> 
        </div>
    )



}

export default InputColore;